import React from 'react';
import AuditTrailList from '../../AuditTrailList';

interface Props {
  authToken: string;
}

const AuditSection: React.FC<Props> = ({ authToken }) => (
  <AuditTrailList authToken={authToken} />
);

export default AuditSection;
